import {
  Box, FormControl, FormLabel, Select,
} from '@chakra-ui/react';
import { useState } from 'react';
import InputSetting from '../../InputSetting';

const containerSizeOptions = [
  { key: 'sm', value: 'sm' },
  { key: '60ch', value: 'md' },
  { key: '70ch', value: 'lg' },
  { key: '3xl', value: 'xl' },
  { key: '100%', value: '100%' },
  { key: 'custom', value: 'custom' },
];

const ContainerSizeField = ({ size, onChange }) => {
  const [showCustomSize, setShowCustomSize] = useState(false);

  const onChangeContainerSize = (e) => {
    setShowCustomSize(e.target.value === 'custom');
    onChange({
      size: e.target.value,
      value: e.target.value === 'custom' ? '100%' : e.target.value,
    });
  };
  const handleCustomSize = (value) => {
    onChange({
      size: 'custom',
      value,
    });
  };
  return (
    <>
      <FormControl>
        <FormLabel fontSize="sm" mb="1">Container size</FormLabel>
        <Select value={size} onChange={onChangeContainerSize}>
          {containerSizeOptions.map(({ key, value }) => <option key={key} value={key}>{value}</option>)}
        </Select>
      </FormControl>
      {showCustomSize && (
        <Box mb="2">
          <InputSetting
            label="Size"
            onChange={handleCustomSize}
            regex={/^[0-9]+ ?(%|px)$/}
            errorMessage="Size must be in % or px"
          />
        </Box>
      )}
    </>
  );
};

export default ContainerSizeField;
